(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jaws-v-product"]) return;
  try {
    
  (function () {
    function initGallery(root) {
      var track = root.querySelector('[data-vp-track]');
      if (!track || track.dataset.vpReady === '1') return;
      track.dataset.vpReady = '1';
      var slides = track.querySelectorAll('.pdp-slide');
      if (slides.length < 2) return;
      var goers = root.querySelectorAll('[data-vp-go]');
      var prev = root.querySelector('[data-vp-prev]');
      var next = root.querySelector('[data-vp-next]');
      function index() {
        return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      }
      function goTo(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function setActive(i) {
        goers.forEach(function (g) {
          g.setAttribute('data-on', parseInt(g.getAttribute('data-vp-go'), 10) === i ? '1' : '0');
        });
      }
      goers.forEach(function (g) {
        g.addEventListener('click', function () { goTo(parseInt(g.getAttribute('data-vp-go'), 10)); });
      });
      if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
      if (next) next.addEventListener('click', function () { goTo(index() + 1); });
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { setActive(index()); }, 60);
      }, { passive: true });
      setActive(0);
    }
    function boot() { document.querySelectorAll('.vesper .pdp-gallery').forEach(initGallery); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('.vesper .pdp-gallery').forEach(initGallery);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
